import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import {formData } from './data'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton'
import {request_edit_user} from '../../requests'
import { onValidateForm } from '../../../../../shared/utility'

const ChangePasswordModal = props => {

    const {open, onClose} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [valid, setValid] = useState(false)


    useEffect(() => {
        setForm(JSON.parse(JSON.stringify(formData)))
    }, [open])


    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        if(id === 'password') temp.passwordConfirmation.value2 = data.value
        setValid(onValidateForm(temp))
        setForm(temp)
        setError(null)
    }

    const onSubmit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        let data2send = {password:form.password.value}
        setLoading(true)
        try {
            await request_edit_user(data2send)
            setLoading(false)
            onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
            setLoading(false)
        }

    }


    return(
        <ModalBase open={open} onClose={onClose} maxWidth='xs'>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Cambio de contraseña</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <LineInputText 
                                data={form.password}
                                onChange={onInputChange}/>
                            </Grid> 
                            <Grid item xs={12}>
                                <LineInputText 
                                data={form.passwordConfirmation}
                                onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton error={error} loading={loading} onSubmit={onSubmit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default ChangePasswordModal